export default "__VITE_ASSET__clTU48lp__"